import { Injectable } from "@angular/core";
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';

@Injectable()
export class JwtHttp {
    constructor(
        private http: Http,
        private router: Router) { }
    }